import Cookies from 'js-cookie';
import { OktaAuth } from '@okta/okta-auth-js';
export class LoginService {
    constructor(config) {
        this.authClient = new OktaAuth({
            redirectUri: config.redirectUri,
            clientId: config.clientId,
            issuer: config.issuer,
            pkce: true,
            responseType: 'code',
        });
        this.userInfoEndpoint = config.userInfo;
        this.cookieDomainEndpoint = config.cookieDomain;
    }
    // not used currently
    async isAuthenticated() {
        const authenticated = await this.authClient.session.exists();
        return authenticated;
    }
    async setCookie() {
        Cookies.set('OEP_li', 'true', { expires: 365, domain: this.cookieDomainEndpoint });
    }
    async login(username, password) {
        const transaction = await this.authClient.signInWithCredentials({ username, password });
        if (transaction.status === 'MFA_REQUIRED') {
            return transaction;
        }
        const response = await this.authClient.token.getWithoutPrompt({ scopes: ['openid'], sessionToken: transaction.sessionToken });
        if (response.tokens.accessToken) {
            this.authClient.tokenManager.add('accessToken', response.tokens.accessToken);
            this.setCookie();
        }
        return transaction;
    }
    // not used currently
    async getUser(authenticated) {
        const auth = await authenticated;
        if (!auth) {
            return;
        }
        const tokenResponse = await this.authClient.tokenManager.get('accessToken');
        const response = await fetch(this.userInfoEndpoint, {
            headers: {
                Authorization: `Bearer ${tokenResponse.accessToken}`,
            },
        });
        const user = await response.json();
        return user;
    }
}
//# sourceMappingURL=service.js.map